








































import { Component, Vue } from "vue-property-decorator";
import { ajaxEventWechatEventList } from '@/server';
import StarrySkyCanvas from "@/components/StarrySkyCanvas.vue";
import {getObjectValue} from '@/assets/js/utils';
import WeuiToast from '@/components/WeuiToast.vue';
// 声明组件*****************
@Component({
  components: {
    StarrySkyCanvas,
    WeuiToast
  }
})
export default class FireAlarm extends Vue {
  // 属性*****************
  private WeuiToastMessage: boolean = true;
  private isbind: boolean = true;
  private alarmList: Array<Object> = [
    // {
    //   enum_device_type: "手动按钮",
    //   thing_id: "5454545454",
    //   address: "北京市昌平区十三陵加油站",
    //   time: "今天 10:09"
    // },
  ];
  created ():void {
    document.title = '报警历史';
  };
  // 挂载完成*****************
  mounted ():void {
    ajaxEventWechatEventList({
      open_id: this['$route']['query']['open_id']
    }).then((res: any)=>{
      const result = getObjectValue(res,'data.list');
      this['alarmList'] = result.map((x: object)=>({
        enum_device_type:getObjectValue(x,'rt_event_confirm.enum_device_type.name'),
        thing_id:getObjectValue(x,'info_device.device_code'),
        address:getObjectValue(x,'info_location.address'),
        time:getObjectValue(x,'rt_event_confirm.accept_time'),
      }))
      this.WeuiToastMessage = false;
    }).catch((error: object)=>{
      this.isbind = false;
      this.WeuiToastMessage = false;
    })
  }
  // computed
  get num(): number {
    return this.alarmList.length;
  }
}
